import React from "react";
import NumberFormat from "react-number-format";

import formatSignedAmount from "../../../../helpers/format-signed-amount";

export const NOTE_MAX_LENGTH = 40;

export const Amount = ({ value }) => {
  const { text, className } = formatSignedAmount(value);
  return <span className={className}>{text}</span>;
};

export const MoneyInput = ({ value, onChange, allowNegative = true, prefix = "$", testId, disabled }) => (
  <NumberFormat
    className="base-input text-align-right"
    thousandSeparator
    prefix={prefix}
    decimalScale={2}
    fixedDecimalScale
    allowNegative={allowNegative}
    placeholder={`${prefix}0.00`}
    value={value ?? ""}
    onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
    disabled={disabled}
    data-testid={testId}
  />
);

export const PercentInput = ({ value, onChange, decimalScale = 0, testId, disabled, placeholder }) => (
  <NumberFormat
    className="base-input"
    suffix="%"
    decimalScale={decimalScale}
    allowNegative={false}
    isAllowed={({ floatValue }) => floatValue === undefined || (floatValue > 0 && floatValue <= 100)}
    placeholder={placeholder}
    value={value ?? ""}
    onValueChange={({ floatValue }) => onChange(floatValue ?? null)}
    disabled={disabled}
    data-testid={testId}
  />
);

export const NoteInput = ({ value, onChange, testId }) => (
  <div className="form-group mt-10">
    <label>Notes</label>
    <input
      type="text"
      className="base-input"
      maxLength={NOTE_MAX_LENGTH}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder="Optional"
      data-testid={testId}
    />
    <div className="tv-commission-note text-align-right">
      {value.length}/{NOTE_MAX_LENGTH}
    </div>
  </div>
);

export const CalcRow = ({ label, value, total, testId, children }) => (
  <tr className={total ? "tv-commission-total" : undefined} data-testid={testId}>
    <td>{total ? <b>{label}</b> : label}</td>
    <td>{children || (total ? <b><Amount value={value}/></b> : <Amount value={value}/>)}</td>
  </tr>
);
